import { render, staticRenderFns } from "./PageUser.vue?vue&type=template&id=bf2201a6&"
import script from "./PageUser.vue?vue&type=script&lang=js&"
export * from "./PageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports